import { SelectOption } from 'govwell-ui/components/Select/types'

import { UserDataFragment, UserType } from '../../../../types/graphql'
import { SelectFieldProps } from '../../../utils/forms'
import UserSearch, { UserSearchGroup } from '../../Selects/UserSearch'

type Props<TKey extends string> = {
  caption?: React.ReactNode
  customDisplay?: (user: UserDataFragment) => React.ReactNode
  getIsOptionDisabled?: (option: SelectOption<UserDataFragment>) => boolean
  includeUsersFromAllOrganizations?: boolean
  isRequired?: boolean
  label?: React.ReactNode
  placeholder?: string
  recordUuids?: string[]
  type?: UserType
  userGroups?: UserSearchGroup[]
} & SelectFieldProps<UserDataFragment, TKey>
const UserSearchField = <TKey extends string>({
  caption,
  customDisplay,
  field,
  getIsOptionDisabled,
  includeUsersFromAllOrganizations,
  isMultiSelect,
  isRequired,
  label,
  placeholder,
  recordUuids,
  type,
  userGroups,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')
  const isInvalid = !!errorMessage
  const commonProps = {
    caption,
    customDisplay,
    errorMessage,
    getIsOptionDisabled,
    includeUsersFromAllOrganizations,
    isInvalid,
    isRequired,
    label,
    onBlur: field.handleBlur,
    placeholder,
    recordUuids,
    type,
    userGroups,
  }
  if (isMultiSelect) {
    return (
      <UserSearch
        isMultiSelect
        onValueChange={field.setValue}
        value={field.state.value}
        {...commonProps}
      />
    )
  }
  return (
    <UserSearch
      isMultiSelect={false}
      onValueChange={field.setValue}
      value={field.state.value}
      {...commonProps}
    />
  )
}

export default UserSearchField
